import React from 'react';
import {CustomComponents} from '../../features/HubPage/types';
import {TilesByPage} from '../../features/ProductStream/TilesByPage';
import {ProductStreamTokenPagination} from '../../features/ProductStreamPagination/ProductStreamTokenPagination';
import {useTokenBasedStreamPages} from '../../features/TokenBasedStreamPages/useTokenBasedStreamPages';
import {SpotlightSkeleton, StreamSkeletons} from './StreamSkeletons';
import {useHubPageStream, useHubPageStreamNext} from './utils/useHubPageStream';
import {useHubTypeFromSlug} from './utils/useHubTypeFromSlug';

interface StreamInterface extends CustomComponents {
  onAddToBasketCtaClick?: ({
    productId,
    filteredSizeId,
    couponPromotionId,
  }: {
    productId: number;
    filteredSizeId?: number;
    couponPromotionId?: string;
  }) => void;
}

export const Stream: React.FC<StreamInterface> = ({
  StreamTileList,
  SliderComponent,
  ProductsComponent,
  onAddToBasketCtaClick,
}) => {
  const hubType = useHubTypeFromSlug();
  const {pages, isNextPageReady, mountNextPage} = useTokenBasedStreamPages({
    uniqueKey: hubType,
    request: useHubPageStream,
    nextRequest: useHubPageStreamNext,
  });

  return (
    <>
      {pages.map((page, i) => (
        <TilesByPage
          key={i}
          page={page}
          loadingComponent={
            page.page === 1 ? SpotlightSkeleton : StreamSkeletons
          }
          gridColumns={undefined}
          StreamTileList={StreamTileList}
          SliderComponent={SliderComponent}
          ProductsComponent={ProductsComponent}
          onAddToBasketCtaClick={onAddToBasketCtaClick}
        />
      ))}
      {isNextPageReady && (
        <ProductStreamTokenPagination
          mountNextPage={mountNextPage}
          rootMargin="300px"
        />
      )}
    </>
  );
};
